module.exports = __webpack_public_path__ + "capital-provider-other-cover.2f3c8cc.png";